import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { Field, PlaidStatus } from 'embed/constants'

const Checkmark = require('embed/components/ApplicationField/check-green.svg')
import ConnectPlaid from 'embed/components/ConnectPlaid'
import ThemeConsumer from 'embed/components/ThemeConsumer'

import Wrapper from '../Wrapper'

const plaidStatusStyles = require('embed/components/ConnectPlaid/StatusIndicator/styles')
const styles = require('embed/styles/application')
const stepByStepStyles = require('./styles')

export interface Props {
  directReferral: boolean
  dispatchBackToStepOne: () => void
  handleChangeAndContinue: (field: Field, value: string) => void
  onBack: () => void
  onContinue: () => void
  onPlaidConnectComplete: () => void
  plaidStatus: PlaidStatus | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

const StepbystepApplicationStepPlaidConnect: React.SFC<Props> = (props) => (
  <ThemeConsumer>
    {({ colorTextSecondary, fontFamilyPrimary, colorPrimary }) =>
      props.plaidStatus === PlaidStatus.Success ? (
        <Wrapper {...props}>
          <div>
            <ThemeConsumer>
              {({ colorBorder, borderRadiusSmall }) => (
                <div
                  className={classnames(
                    plaidStatusStyles.notice,
                    css(`
                  border-color: ${colorBorder} !important;
                  border-radius: ${borderRadiusSmall}
                `),
                  )}
                >
                  <>
                    <div className={plaidStatusStyles.header}>
                      <Checkmark /> <strong>Link successful!</strong>
                    </div>
                    <p>Confirm everything looks correct and add the last details for personalized offers.</p>
                  </>
                </div>
              )}
            </ThemeConsumer>
          </div>
        </Wrapper>
      ) : (
        <Wrapper disableCTA={true} {...props}>
          <h2
            className={classnames(
              styles.title,
              css`
                font-family: ${fontFamilyPrimary};
              `,
            )}
          >
            Want to speed up your application?
          </h2>

          <div>
            <ConnectPlaid onConnectComplete={props.onPlaidConnectComplete} />
            <div className={styles.dividerContainer}>
              <div
                className={classnames(
                  styles.divider,
                  css`
                    background-color: ${colorTextSecondary};
                  `,
                )}
              />
              <div
                className={classnames(
                  styles.dividerOr,
                  css`
                    color: ${colorTextSecondary};
                  `,
                )}
              >
                OR
              </div>
              <div
                className={classnames(
                  styles.divider,
                  css`
                    background-color: ${colorTextSecondary};
                  `,
                )}
              />
            </div>
          </div>

          <div
            className={classnames(
              styles.enterManually,
              stepByStepStyles.enterManually,
              css`
                color: ${colorPrimary};
              `,
            )}
            onClick={props.onContinue}
          >
            Enter your information manually
          </div>
        </Wrapper>
      )
    }
  </ThemeConsumer>
)

export default StepbystepApplicationStepPlaidConnect
